import {Component, OnInit} from '@angular/core';
import {ChannelsService} from "../channels-service.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {ChannelConfig} from "../../../model/channels.model";
import {Level, Message} from "../../../model/message.component";

@Component({
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListChannelsComponent implements OnInit {

  private channels: ChannelConfig[] = [];

  frontend = {
    api: false,
    batch: false,
    realtime: false,
    ocr: false,
    nlp: false,
    ai: false,
  };

  data = {
    entry: false,
    event: false,
    request: false,
    customer: false,
    account: false,
    transaction: false,
  };

  vertical = {
    list: false,
    db: false,
    wlm: false,
    cdd: false,
    aml: false,
  };

  constructor(
    private viewManager: ViewManagerService,
    private service: ChannelsService
  ) {
  }

  ngOnInit(): void {
    this.service.all()
      .pipe()
      .subscribe({
        next: (result) => {
          this.channels = result;
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

  get selectedFrontend(): string[] {
    return Object.entries(this.frontend)
      .filter(([, v]) => v)
      .map(([k]) => k);
  }

  get selectedData(): string[] {
    return Object.entries(this.data)
      .filter(([, v]) => v)
      .map(([k]) => k);
  }

  get selectedVertical(): string[] {
    return Object.entries(this.vertical)
      .filter(([, v]) => v)
      .map(([k]) => k);
  }

  get selectedChannels() {
    const selectedFrontends = this.selectedFrontend;
    const selectedVerticals = this.selectedVertical;

    return this.channels.filter(c =>
      (selectedFrontends.length === 0 || (c.frontend && selectedFrontends.includes(c.frontend))) &&
      (this.selectedData.length === 0 || (c.data && this.selectedData.includes(c.data))) &&
      (selectedVerticals.length === 0 || (c.vertical && selectedVerticals.includes(c.vertical)))
    );
  }
}
